
import OverlayGridItem from './OverlayGridItem'
import AppCarousel from './AppCarousel'

export default {
  name: 'OverlaysSection',
  components: {
    AppCarousel,
    OverlayGridItem
  },
  props: {
    name: {
      type: String,
      default: null
    },
    themes: {
      type: Array,
      default: () => []
    },
    portrait: Boolean,
    presentingMode: Boolean,
    hoverMode: Boolean,
    showPremiumBadge: {
      type: Boolean,
      default: false
    }
  }
}
